import { render, staticRenderFns } from "./BetOddsSummary.vue?vue&type=template&id=77ec687c"
import script from "./BetOddsSummary.vue?vue&type=script&lang=js"
export * from "./BetOddsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports